module.exports = __webpack_public_path__ + "static/img/rrrr_27.22ad624.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_27.png
// module id = C/Bq
// module chunks = 1